import React from 'react';
import PropTypes from 'prop-types';
import s from './Icon.scss';

var Icon = function Icon(_ref) {
  var id = _ref.id,
      children = _ref.children,
      viewBox = _ref.viewBox,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height;
  return React.createElement(
    'svg',
    {
      id: id,
      className: s.iconDefault,
      width: width || size,
      height: height || size,
      viewBox: viewBox
    },
    children
  );
};

Icon.defaultProps = {
  size: '1em'
};

Icon.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.any,
  viewBox: PropTypes.string.isRequired
};

export default Icon;
//# sourceMappingURL=Icon.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/Icon.js